import * as React from "react";
const SvgFiRrBookDead = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17 0H7C4.243 0 2 2.243 2 5v15c0 2.206 1.794 4 4 4h11c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5M7 2h10c1.654 0 3 1.346 3 3v11H6a4 4 0 0 0-2 .537V5c0-1.654 1.346-3 3-3m10 20H6c-1.103 0-2-.897-2-2s.897-2 2-2h14v1c0 1.654-1.346 3-3 3"
    />
    <path
      fill="#062147"
      d="M11.601 5.019C9.523 5.221 8 7.089 8 9.177v1.822a1 1 0 0 0 1 1h1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-2a4.004 4.004 0 0 0-4.399-3.98m-1.353 5.231a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5m3.492 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
    />
  </svg>
);
export default SvgFiRrBookDead;
